import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{ 
      maxWidth: '900px', 
      margin: '50px auto', 
      padding: '40px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333',
      textAlign: 'left',
      background: '#fff',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      borderRadius: '8px'
    }}>
      <h1 style={{ color: '#667eea', marginBottom: '10px' }}>Privacy Policy</h1>
      <p style={{ color: '#64748b', marginBottom: '30px' }}><em>Last updated: January 28, 2026</em></p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>What Information We Collect</h2>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '8px' }}><strong>Account Info:</strong> Name, email, password (encrypted)</li>
        <li style={{ marginBottom: '8px' }}><strong>Documents:</strong> LaTeX files and projects you create</li>
        <li style={{ marginBottom: '8px' }}><strong>Usage Data:</strong> Login times, features used (for improving the service)</li>
      </ul>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>How We Use Your Information</h2>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '8px' }}>To provide the LaTeX editing service</li>
        <li style={{ marginBottom: '8px' }}>To save and compile your documents</li>
        <li style={{ marginBottom: '8px' }}>To improve the platform based on feedback</li>
      </ul>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>How We Protect Your Information</h2>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '8px' }}>Passwords are encrypted (bcrypt)</li>
        <li style={{ marginBottom: '8px' }}>Your documents are stored privately and not shared</li>
        <li style={{ marginBottom: '8px' }}>We use secure connections (HTTPS)</li>
      </ul>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>What We DON'T Do</h2>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '8px' }}>❌ We DO NOT sell your data to third parties</li>
        <li style={{ marginBottom: '8px' }}>❌ We DO NOT read your documents</li>
        <li style={{ marginBottom: '8px' }}>❌ We DO NOT share your information with advertisers</li>
      </ul>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Cookies</h2>
      <p>We use essential cookies for authentication (keeping you logged in). No tracking or advertising cookies.</p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Data Retention</h2>
      <p>Your data is kept as long as your account is active. Delete your account anytime through the app.</p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Your Rights</h2>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '8px' }}>Access your data anytime (it's in your projects)</li>
        <li style={{ marginBottom: '8px' }}>Delete your account and all data</li>
        <li style={{ marginBottom: '8px' }}>Export your projects as ZIP files</li>
      </ul>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Changes to Privacy Policy</h2>
      <p>We may update this policy. We'll notify users of major changes.</p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Contact</h2>
      <p>Privacy questions? Use the Feedback button in the app or email us at support@latexlab.com</p>
      
      <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #e2e8f0', textAlign: 'center' }}>
        <a href="/" style={{ color: '#667eea', textDecoration: 'none' }}>← Back to Home</a>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
